import type {
  ParameterTimeSeriesChartResult,
  ParametersModeledTimeSeriesForCoordinatesResult,
  ParametersObservedTimeSeriesForLocationResult,
  ParametersUnit,
  ParameterTimeSeriesConfiguration,
} from "@/lib/api/types";
import type { TimeSeriesConfig } from "@/components/graph/graph.types";

export type ParameterTimeSeriesChartResultContext = {
  parameterLabel: string;
  unit?: ParametersUnit;
};

export function toParameterTimeSeriesChartResultFromObserved(
  result: ParametersObservedTimeSeriesForLocationResult,
  context: ParameterTimeSeriesChartResultContext,
): ParameterTimeSeriesChartResult {
  return {
    parameter: {
      id: result.parameter_id,
      label: context.parameterLabel,
      unit: result.data?.unit ?? context.unit,
    },
    data: result.data,
  };
}

export function toParameterTimeSeriesChartResultFromModeled(
  result: ParametersModeledTimeSeriesForCoordinatesResult,
  context: ParameterTimeSeriesChartResultContext,
): ParameterTimeSeriesChartResult {
  return {
    parameter: {
      id: result.parameter_id,
      label: context.parameterLabel,
      unit: result.data.unit ?? context.unit,
    },
    data: result.data,
  };
}

export function resolveChartSeriesLabel(
  parameterId: string,
  timeSeriesConfigs: TimeSeriesConfig[],
): string {
  for (const config of timeSeriesConfigs) {
    const series = config.series.find((entry) => entry.parameter_id === parameterId);
    if (series) return series.label ?? parameterId;
  }
  return parameterId;
}

export function resolveChartConfigUnit(
  parameterId: string,
  timeSeriesConfigurations: ParameterTimeSeriesConfiguration[],
): ParametersUnit | undefined {
  for (const config of timeSeriesConfigurations) {
    if (config.series.some((series) => series.parameter_id === parameterId)) {
      return config.unit ?? undefined;
    }
  }
  return undefined;
}

export function resolveTimeSeriesConfigUnit(
  parameterId: string,
  timeSeriesConfigs: TimeSeriesConfig[],
): ParametersUnit | undefined {
  for (const config of timeSeriesConfigs) {
    if (config.series.some((series) => series.parameter_id === parameterId)) {
      return config.unit;
    }
  }
  return undefined;
}
